import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ListenAnywhere from "@/components/ListenAnywhere";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function DirectoryPage() {
  return (
    <div className="relative min-h-screen bg-zinc-950 text-zinc-100" data-testid="directory-page">
      <Header />
      <div className="px-4 md:px-10 pt-8 pb-2">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-xs tracking-widest uppercase text-zinc-300 hover:text-red-500 transition-colors"
          data-testid="directory-back-home"
        >
          <ArrowLeft className="w-3 h-3" /> Back to home
        </Link>
      </div>
      <ListenAnywhere />
      <Footer />
    </div>
  );
}
